import React, { useContext, useEffect, useState } from "react";
import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import MenuInfoHospitalPersonnel from "./MenuInfoHospitalPersonnel";
import * as notifyApi from "../../../service/notifyApi";
import { HashLoader } from "react-spinners";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";
import moment from "moment/moment";

function MenuHospitalPersonnel({ menuActive }) {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const [new_notify, setNew_nottify] = useState(false);

  const [open, setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      setGetNotificationTotal(0);
    } else {
      // console.log(getNotificationTotal)
    }
    getRequestPermission();
    setUserRole(user); //ใช้อัพเดท route path ทุกครั้งถ้ามีการ อัพเดท
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        getRequestPermission();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <>
      <nav className="bg-white z-10 fixed top-0 left-0 right-0 h-28 md:h-[70px] w-full shadow-xl rounded-b-3xl flex justify-between items-center">
        {/* logo&appname */}
        <div className="flex">
          <button onClick={() => navigate("/searchDataPatient")}>
            <img
              className="ml-[50px] lg:ml-[30px] md:ml-[20px] sm:ml-0xsm:ml-0 lg:h-[50px] md:h-[20px] sm:h-[10px]"
              src={require("../../../asset/image/logo.svg").default}
              alt=""
            ></img>
          </button>
        </div>
        {/* mobile */}
        <div className="flex justify-end items-center gap-10 invisible text-3xl absolute right-10 top-15 md:visible">
          <ul
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center relative"
                >
                  <img
                    onClick={() => {
                      setOpen(false);
                    }}
                    className="w-[48px] h-[48px] rounded-full lg:w-[40px] lg:h-[40px]"
                    src="/notify.svg"
                    alt="notify"
                  />
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-4 lg:h-4 text-[0.60rem] leading-tight font-medium rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF] `}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${notifyList.length > 0 ? "mt-7 w-[320px] rounded-2xl" : "rounded-xl"} z-[19]`}
              >
                <div className="h-full">
                  <div
                    id="box_notification"
                    className={`${notifyList.length > 3 ? "overflow-y-scroll" : "overflow-hidden"} `}
                  >
                    <div
                      className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                    >
                      {notifyList.length ? (
                        <>
                          {notifyList.map((i, idx) => (
                            <div key={idx} className="m-3">
                              <div
                                onClick={() => {}}
                                className="hover:rounded-lg hover:bg-[#fdf4f0] hover:cursor-pointer p-2"
                              >
                                <div className="grid grid-cols-[auto_100px]">
                                  <div className="font-bold text-[#2E2E2E]">
                                    {i["payload"]["topic"]}
                                  </div>
                                  <div className="text-[#FFC0A4]">
                                    {moment(
                                      i["create_date"]["timestamp"],
                                    ).format("LT") +
                                      " " +
                                      moment(i["create_date"]?.["timestamp"])
                                        .add(543, "years")
                                        .format("Do MMM")}
                                  </div>
                                </div>
                                <div className="text-[#FF9768] font-medium flex justify-start py-[5px] ">
                                  {i["payload"]["detail"]}
                                </div>
                              </div>
                              <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-[#2E2E2E] font-medium">
                          ไม่พบการแจ้งเตือน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </MenuList>
            </Menu>
          </ul>
          <ul>
            <Menu open={open}>
              <MenuHandler>
                <div>
                  {open ? (
                    <XMarkIcon
                      onClick={() => setOpen(!open)}
                      className="w-6 stroke-[#FF9768] stroke-[3px]"
                    />
                  ) : (
                    <Bars3Icon
                      onClick={() => setOpen(!open)}
                      className="w-6 stroke-[#FF9768] stroke-[3px]"
                    />
                  )}
                </div>
              </MenuHandler>
              <MenuList className="flex flex-col items-center md:gap-y-3 gap-y-5 h-[510px] md:h-auto rounded-3xl ">
                <div
                  onClick={() => navigate("/hospital/home")}
                  className={`text-md ${menuActive === "homehospital" ? "text-[#FF9768] font-bold" : "text-[#000000]"}`}
                >
                  หน้าหลัก
                </div>
                <div
                  onClick={() => {
                    localStorage.clear();
                    navigate("/login");
                  }}
                  className="flex justify-center items-center bg-white rounded-full w-[120px] md:w-full h-[25px] ring-1 ring-[#FF9768]"
                >
                  <img
                    src={require("../../../asset/icon/logout.svg").default}
                    alt=""
                    className="mr-2 w-[12px]"
                  />
                  <p className="text-[#FF9768] text-xs">ออกจากระบบ</p>
                </div>
              </MenuList>
            </Menu>
          </ul>
        </div>

        {/* web */}
        <ul className="h-12 flex items-center md:hidden">
          {/* หน้าหลัก*/}
          <li>
            <button
              onClick={() => navigate("/hospital/home")}
              className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${menuActive === "homehospital" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
            >
              หน้าหลัก
            </button>
          </li>

          {/* ติดต่อเรา */}
          <li>
            <button
              onClick={() => navigate("/doctor/contact")}
              className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs  ${menuActive === "contact" ? "text-[#FF9768] font-bold" : "text-[#000000]"} hover:text-[#FF9768]`}
            >
              ติดต่อเรา
            </button>
          </li>
          {/* เเจ้งเตือน */}
          <li
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center mr-3 relative"
                >
                  <img
                    className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]"
                    src="/notify.svg"
                    alt="notify"
                  />
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${notifyList.length > 0 ? "mt-7  w-[400px] rounded-2xl" : "rounded-xl"} z-[9] `}
              >
                <div
                  id="web_box_notification"
                  className={`${notifyList.length > 3 ? "overflow-y-scroll" : "overflow-hidden"} `}
                >
                  <div
                    className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                  >
                    {notifyList.length ? (
                      <>
                        {notifyList.map((i, idx) => (
                          <div key={idx} className="m-3">
                            <div
                              onClick={() => {}}
                              className="hover:rounded-lg hover:bg-[#fdf4f0] hover:cursor-pointer p-2"
                            >
                              <div className="grid grid-cols-[auto_100px]">
                                <div className="font-bold text-[#2E2E2E]">
                                  {i["payload"]["topic"]}
                                </div>
                                <div className="text-[#FFC0A4]">
                                  {moment(i["create_date"]["timestamp"]).format(
                                    "LT",
                                  ) +
                                    " " +
                                    moment(i["create_date"]?.["timestamp"])
                                      .add(543, "years")
                                      .format("Do MMM")}
                                </div>
                              </div>
                              <div className="text-[#FF9768] font-medium flex justify-start py-[5px] ">
                                {i["payload"]["detail"]}
                              </div>
                            </div>
                            <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center text-[#2E2E2E] font-medium">
                        ไม่พบการแจ้งเตือน
                      </div>
                    )}
                  </div>
                </div>
              </MenuList>
            </Menu>
          </li>
          {/* ข้อมูลส่วนตัว */}
          <li>
            <MenuInfoHospitalPersonnel />
          </li>
        </ul>
      </nav>
    </>
  );
}

export default MenuHospitalPersonnel;
